/* eslint-disable */
var $ = window.jQuery = require('jquery');
import toast from '../../services/toast';
import {
  bus
} from '../../main';
import {
  mapGetters,
  mapState
} from 'vuex';
import { VueEditor } from "vue2-editor";

export default {
  name: 'edit-topic',
  components: {
    VueEditor
  },
  props: ['updateTopicID'],
  data() {
    return {
      name: '',
      description: '',
      submitted: false,
      section: '',
      editorOptions: {
        placeholder: '',
        editorToolbar: ['bold','italic','link',  '|', 'heading', 'fontFamily','fontSize','undo','redo']
      },
      editorData:''
    }
  },
  computed: {
    ...mapGetters([
      'gettopicsdataState',
      'getcourseSectionByIDDataState'
    ]),
    getTopicsDataById() {
      this.$store.dispatch('get_topics', {
        id: this.updateTopicID
      }).then((res) => {
        if (res.status == '200' || res.status == '202') {
          this.name = this.$store.getters.gettopicsdataState.data.name
          this.description = this.$store.getters.gettopicsdataState.data.description
          setTimeout(()=>{
            CKEDITOR.instances['update_topic_desc'].setData(this.description);
          },100)
        }
      }).catch((err) => {})
    }
  },
  mounted() {
    this.getTopicsDataById
    this.createEditor()
  },
  methods: {
    createEditor() {
      CKEDITOR.replace('update_topic_desc',{
        extraPlugins: 'mathjax',
        mathJaxLib: 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.4/MathJax.js?config=TeX-AMS_HTML',
        height:150,
      });
      CKEDITOR.instances['update_topic_desc'].on('change', () => {
        var content1Length = CKEDITOR.instances['update_topic_desc'].getData().replace(/<[^>]*>/gi, '').length;
        if(content1Length > 0){
          $('.custom_editor_for_option #update_topic_desc').attr('aria-invalid', 'false')
          $('.custom_editor_for_option #update_topic_desc').removeClass('is-invalid')
          this.description = CKEDITOR.instances['update_topic_desc'].getData()
        }else{
          $('.custom_editor_for_option #update_topic_desc').attr('aria-invalid', 'true')
          $('.custom_editor_for_option #update_topic_desc').addClass('is-invalid')
          this.description = ''
        }
      })
    },
    getCourseDetailsAgain() {
      this.$store.dispatch('sectionbycourseId', {
        id: this.$route.params.id
      }).then((res) => {
        bus.$emit('HideEditTopicPopup', false)
      }).catch((err) => {})
    },
    validateSectionBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
          let formData = new FormData();
          formData.append('name', this.name);
          formData.append('description', this.description);
          this.$store.dispatch('update_topic', {
              data: {
                formdata: formData,
                id: this.updateTopicID
              }
            })
            .then((res) => {
              this.getCourseDetailsAgain();
              this.name = '';
              this.description = '';
              toast.success(res.data.msg);
              bus.$emit('HideEditTopicPopup', false)
              this.$validator.reset();
            })
            .catch((err) => {})
          return
        }
      });
    },
    popupCloseFun() {
      bus.$emit('HideEditTopicPopup', false)
    },
  }
}